import { createPluginFactory } from '@udecode/plate-common';

const ELEMENT_HR = 'hr';
const createHorizontalRulePlugin = createPluginFactory({
  key: ELEMENT_HR,
  isElement: true,
  isVoid: true,
  deserializeHtml: {
    rules: [{
      validNodeName: 'HR'
    }]
  }
});

export { ELEMENT_HR, createHorizontalRulePlugin };
//# sourceMappingURL=index.es.js.map
